import { render, staticRenderFns } from "./report-edit.vue?vue&type=template&id=ef6e77d4"
import script from "./report-edit.vue?vue&type=script&lang=js"
export * from "./report-edit.vue?vue&type=script&lang=js"
import style0 from "./report-edit.vue?vue&type=style&index=0&id=ef6e77d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports